import apiClient from "../http/apiClient";
import { INVOICE_ENDPOINTS } from "../http/endpoints";

const pendingInternalInvoiceUrl = (pendingId) =>
  `${INVOICE_ENDPOINTS.pending}${pendingId}/create-internal-invoice/`;
const documentUrl = (id) => `${INVOICE_ENDPOINTS.documents}${id}/`;

export async function getSettings() {
  const response = await apiClient.get(INVOICE_ENDPOINTS.settings);
  return response.data;
}

export async function updateSettings(payload = {}) {
  const response = await apiClient.put(INVOICE_ENDPOINTS.settings, payload);
  return response.data;
}

export async function listPending(params = {}) {
  const response = await apiClient.get(INVOICE_ENDPOINTS.pending, { params });
  return response.data;
}

export async function createPendingFromSale(payload = {}) {
  const response = await apiClient.post(INVOICE_ENDPOINTS.pendingFromSale, payload);
  return response.data;
}

export async function createInternalInvoiceFromPending(pendingId) {
  const response = await apiClient.post(pendingInternalInvoiceUrl(pendingId));
  return response.data;
}

export async function listDocuments(params = {}) {
  const response = await apiClient.get(INVOICE_ENDPOINTS.documents, { params });
  return response.data;
}

export async function getDocument(id) {
  const response = await apiClient.get(documentUrl(id));
  return response.data;
}

export const invoiceService = {
  getSettings,
  updateSettings,
  listPending,
  createPendingFromSale,
  createInternalInvoiceFromPending,
  listDocuments,
  getDocument,
};

export default invoiceService;
